import React, { useEffect, useRef } from 'react';
import { Box } from "@mui/material";

import environment from '../../environment/environment';
import useMap from '../../hooks/mapbox/useMap';
import useMarker from '../../hooks/mapbox/useMarker';
import MarkerMap from "../../assets/images/marker-map.png";

import { mapBox } from "./../../common/staticVariables";

const MapAnalytics = ({parentHeight, formatted_anomaly, center_camera_coordinates}) => {
    
    const mapContainerRef = useRef();
    const mapRef = useRef();
    const {map, mapLoaded, initMap, addSource, getSource} = useMap(mapRef);
    const {addMarkersWithLayer, getMarkersWithLayer} = useMarker(map)

    useEffect(()=>{

        if (!mapLoaded) {
            let mapOpts = {
                token: environment.mapBox.mapBoxToken,
                containerRef: mapContainerRef.current,
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [-24, 42],
                zoom: 1
            }
            initMap(mapOpts);
            return;
        }

        // 2. add markers
        // 2.1 initialize source
        if(formatted_anomaly == null) return;
        var source_id = 'anomaly-detection-map-id';
        if(getSource(source_id) == null){ // checks if source is already available. else, do nothing.
            var mapBoxCustomData = formatted_anomaly;
            console.log("mapBoxCustomData: ", mapBoxCustomData)
            let obj = {
                type: 'geojson',
                data: mapBoxCustomData
            }
            addSource(source_id, obj); // returns void
        }

        // 2. get marker layer options
        var markers_layer_id = 'anomaly-detection-markers-layer-id';
        var marker_layer = getMarkersWithLayer(markers_layer_id);
        var marker_layer_options;
        var camera_options;
        if(marker_layer == null){
            var img_marker_id = mapBox.marker.icon_img_id
            marker_layer_options = {
                id: markers_layer_id,
                icon_img_id: img_marker_id,
                icon_src: MarkerMap,
                size: 0.3,
                popup: {
                    isHover: true,
                }
            }
            camera_options = {
                center: center_camera_coordinates, // center coordinates of the Philippines
                zoom: 5,
            }
            // 3. final marker setup
            addMarkersWithLayer(source_id, marker_layer_options, camera_options);
            return;
        }
        // 3. update center camera and markers
        camera_options = {
            center: center_camera_coordinates,
            zoom: 5,
        }
        let updated_props = {
            camera: camera_options
        }
        marker_layer.updateData(formatted_anomaly)  // recenter camera
        marker_layer.updateMarkers(updated_props); // update markers
    }, [formatted_anomaly, mapLoaded, center_camera_coordinates])

    return(
        <Box id="map" ref={mapContainerRef} sx={{ height: parentHeight }}/>
    )

}

export default MapAnalytics;